import { useMutation } from '@tanstack/react-query'

import { useCreateStateMutation } from '@/hooks/useCreateStateMutation'
import { STATE_KEY, STATE_TYPE } from '@/lib/constants'

export function useRecordInteractionMutation() {
  const createUserStateMutation = useCreateStateMutation()

  return useMutation({
    mutationFn: () =>
      createUserStateMutation.mutateAsync({
        stateKey: STATE_KEY.hasInteractedWithClaimReferralModal,
        stateValue: true,
        stateType: STATE_TYPE.user,
      }),
  })
}
